import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { useDispatch } from 'react-redux';
import {
    editComplaint,
    fetchComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import moment from 'moment';

const PendingModal = ({
    openPendingModal,
    setOpenPendingModal,
    complaintData,
    page,
    status,
}) => {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...complaintData,
            pendingDate: '',
            PendingModal: '',
        },
        validationSchema: object({
            pendingDate: string().required('Pending date is required'),
            pendingNotes: string().required(),

        }),
        onSubmit: async (values) => {
            await dispatch(editComplaint({ ...values, status: 'pending' }));
            await dispatch(fetchComplaints({ populate: true, page, status }));
            setOpenPendingModal(false);
            formik.resetForm();
        },
    });
    useEffect(() => {
        if (openPendingModal) {
            formik.setFieldValue("pendingDate", moment().valueOf());
        }
    }, [openPendingModal]);
    return (
        <ModalBasic
            modalOpen={openPendingModal}
            setModalOpen={setOpenPendingModal}
            title="Move to Pending"
            max_width="max-w-lg"
        >
            <form
                className="flex flex-col gap-4 p-5 min-h-[260px]"
                onSubmit={formik.handleSubmit}
            >
                <div className="grid grid-cols-2 gap-3 pb-4 border-b border-slate-200">
                    <FormikInputGroup formik={formik} label="Complaint No." name="complaintNumber" readOnly value={`CMP-${formik.values.complaintNumber || ''}`} />
                    <FormikInputGroup formik={formik} label="Customer" name="customer.name" readOnly />
                    <FormikInputGroup formik={formik} label="Company" name="customer.companyData.name" readOnly />
                    <FormikInputGroup formik={formik} label="Machine" name="product.name" readOnly />
                    <FormikInputGroup formik={formik} label="Technician" name="assignedTo" readOnly />
                    <div className="col-span-2">
                        <FormikInputGroup formik={formik} label="Description" name="description" readOnly fullWidth />
                    </div>
                </div>

                <FormikInputDateGroup
                    formik={formik}
                    label="Pending Date"
                    name="pendingDate"
                    required
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="dd/MM/yyyy HH:mm"
                />
                <FormikInputGroup
                    formik={formik}
                    name="pendingNotes"
                    required
                    label="pending Note"
                />
                <div className="mt-auto">
                    <PrimaryButton
                        type="submit"
                        disabled={formik.isSubmitting}
                        className="w-full"
                    >
                        {formik.isSubmitting ? 'Saving...' : 'Submit'}
                    </PrimaryButton>
                </div>
            </form>
        </ModalBasic>
    );
};

export default PendingModal;
